<script setup lang="ts">
  import {
    Card,
    CardHeader,
    CardTitle,
    CardDescription,
    CardContent,
    CardFooter
  } from '../ui/card/index'
  import { ref, defineProps, defineEmits } from 'vue'
  import { Label } from '../ui/label'
  import { Input } from '../ui/input'
  import { Button } from '../ui/button'
  import ClientActionService from '../../services/clientaction.service'
  import { genericErrorToast } from '@/lib/toasts'
  const props = defineProps({
    feedbackId: {
      type: String,
      required: true
    }
  })
  const firstName = ref('')
  const lastName = ref('')
  const email = ref('')
  const isSubmitting = ref(false) // Track loading state
  const emit = defineEmits(['feedbackSubmitted'])
  const handleSubmit = () => {
    isSubmitting.value = true // Set loading state

    const formData = {
      first_name: firstName.value,
      last_name: lastName.value,
      email: email.value
    }

    ClientActionService.updateVoiceBotFeedback(props.feedbackId, formData)
      .then((_data) => {
        emit('feedbackSubmitted')
      })
      .catch((error) => {
        genericErrorToast()
        console.error(error)
      })
      .finally(() => {
        isSubmitting.value = false // Reset loading state
      })
  }
</script>
<template>
  <Card class="border-[#000000] bg-white shadow-lg">
    <CardHeader class="space-y-1">
      <CardTitle class="text-2xl">Datenabgleich</CardTitle>
      <CardDescription>Haben wir Ihre Daten richtig aufgenommen?</CardDescription>
    </CardHeader>
    <CardContent class="grid gap-4">
      <div class="grid gap-2">
        <Label
          class="bg-transparent"
          for="firstName"
        >
          Vorname
        </Label>
        <Input
          id="firstName"
          v-model="firstName"
          type="text"
          placeholder="Max"
        />
      </div>
      <div class="grid gap-2">
        <Label
          class="bg-transparent"
          for="lastName"
        >
          Nachname
        </Label>
        <Input
          id="lastName"
          v-model="lastName"
          type="text"
          placeholder="Mustermann"
        />
      </div>
      <div class="grid gap-2">
        <Label
          class="bg-transparent"
          for="email"
        >
          E-Mail-Adresse
        </Label>
        <Input
          id="email"
          v-model="email"
          type="email"
          placeholder="max@mustermann.de"
        />
      </div>
    </CardContent>
    <CardFooter class="flex flex-col items-center">
      <Button
        class="mb-4 w-full bg-[rgb(124_58_237/var(--tw-bg-opacity))] hover:bg-violet-900"
        :disabled="isSubmitting"
        @click="handleSubmit"
      >
        <template #default>
          {{ isSubmitting ? 'Speichere...' : 'Speichern' }}
        </template>
      </Button>
      <!--            <div class="text-center">-->
      <!--                <p class="mb-2">Powered By</p>-->
      <!--                <img class="w-24 h-10" src="https://s3-eu-central-1.ionoscloud.com/jupus/images/logo.svg"-->
      <!--                    alt="Jupus Logo" />-->
      <!--            </div>-->
    </CardFooter>
  </Card>
</template>
